

import { useRef, useState } from "react";
import { Image } from "react-bootstrap";

const SelectionBox = (props: any) => {
  const cropperRef: any = useRef<HTMLImageElement>(null);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imageError, setImageError] = useState<string | null>(null);
  const cropComplete = async (value: any) => {
    const parentElementWidth = cropperRef?.current?.clientWidth || 0;
    const parentElementHeight = cropperRef?.current?.clientHeight || 0;

    const croppedArea = {
      x: value?.startX * parentElementWidth,
      y: value?.startY * parentElementHeight,
      width: value?.width * parentElementWidth,
      height: value?.height * parentElementHeight,
      unit: "px",
    };
    if (croppedArea?.width && croppedArea?.height) {
      let obj = {
        area: croppedArea,
        ref: cropperRef.current,
      };
      console.log("cropComplete 1");
      props?.onChange(obj);
    } else {
      console.log("cropComplete 2");
      props?.onChange(null);
    }
  };

  return (
    <div className="detailScreen-CropPdf">
      <div className="detailScreen-imageContainer">
        {isImageLoading && <div>Loading image...</div>}
        {imageError && <div>Error: {imageError}</div>}
        {props?.page?.imageUrl ? (
          <Image
            ref={cropperRef}
            src={props?.page?.imageUrl}
            className="detailScreen-CropPdfImage"
            onLoad={() => setIsImageLoading(false)}
            onError={(e) => {
              setIsImageLoading(false);
              setImageError("Failed to load image");
              console.error("Image load error:", e);
            }}
          />
        ) : (
          <div>No image URL provided</div>
        )}
        {props?.page?.coords?.map((pos: any, index: number) => (
          <div
            className="detailScreen-croodarea"
            key={index}
            style={{
              left: `${pos.startX * 100}%`,
              top: `${pos.startY * 100}%`,
              width: `${pos.width * 100}%`,
              height: `${pos.height * 100}%`,
            }}
            onClick={() => cropComplete(pos)}
          />
        ))}
      </div>
    </div>
  );
};

export default SelectionBox;
